<template>
	<el-container style="display: flex;flex-direction: column;">
		<el-main style="width: 100%;display: flex;flex-direction: column;">
			<div style="margin-bottom: 30px;" >
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">首页</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div style="text-align: left;" class="item_font">
				优先运行：
				<i class="el-icon-success" style="color: #FF3F51;"><span style="margin-left: 10px;color: #FF3F51;font-weight: bold;" class="item_font">{{AIModelStatus.status==4?model2:model1}}</span></i>
				<span style="margin-left: 20px;color: #D9D9D9;" class="item_font">{{AIModelStatus.status==4?model1:model2}}</span>
			</div>
			<div class="simple">
				<div style="width: 96%;margin-left: 2%; display: flex;flex-direction: row;justify-content:space-between;">
					<div style="display: flex;flex-direction: row;justify-content:space-between;">
						<div style="font-size: 16px;color: #409EFF;margin-right: 50px;" class="item_font">简单模型</div>
						<div style="font: 14px Arial, Helvetica, sans-serif;line-height:120px;" class="item_font">
							更新时间：
							<span style="color: #409EFF;line-height:120px;">{{simpleModelStatus.updateTime}}</span>
						</div>
					</div>
					<div><el-button type="primary" size="mini" style="margin-left: 30px;" @click="editSimpleModel" class="item_font">编辑模型</el-button></div>
				</div>
			</div>
			<div class="complex">
				<div style="font-size: 16px;color: #409EFF;text-align: left;line-height: 50px;margin-left: 2%;margin-top: 15px;" class="item_font">高级模型</div>
				<div style="height:100px; width: 96%;margin-left: 2%; display: flex;flex-direction: row;justify-content:space-between;" class="item_font">
					<div class="con" style="font: 15px Arial, Helvetica, sans-serif;line-height: 35px;">
						更新时间：
						<div div class="data">{{AIModelStatus.updateTime}}</div>
					</div>
					<div class="con">
						<div>语料：</div>
						<div class="data">{{AIModelStatus.corpusTotal}}</div>
					</div>
					<div class="con">
						<div>主题：</div>
						<div class="data">{{AIModelStatus.topicTotal}}</div>
					</div>
					<div class="con">
						<div>话术：</div>
						<div class="data">{{AIModelStatus.talkCorpusTotal}}</div>
					</div>
					<div>
						<el-button :disabled="canotEdit" type="primary" size="mini" @click="startEditAIModel" class="item_font">编辑模型</el-button>
						<el-button :disabled="!waitPublish" type="primary" size="mini" @click="publishModel" class="item_font">发布模型</el-button>
						<div v-show="waitPublish" style="font-size: 12px;color: #ff3f51;line-height: 25px;height: 55px;" class="item_font">您有新的修改尚未发布</div>
					</div>
				</div>
			</div>
			<!-- <div style="display: flex;flex-direction: row;align-items: center;margin-top: 30px;">
				<div style="font: 14px Arial, Helvetica, sans-serif;">更新时间：<span class="data" style="color: #409EFF;">20201122-13:45:55</span></div>
				<div style="margin-left: 20px;font: 14px Arial, Helvetica, sans-serif;" >语料：<span class="data" style="color: #409EFF;">14678</span></div>
				<div style="margin-left: 20px;font: 14px Arial, Helvetica, sans-serif;">话题：<span class="data" style="color: #409EFF;">23</span></div>
				<div style="margin-left: 20px;font: 14px Arial, Helvetica, sans-serif;">话术：<span class="data" style="color: #409EFF;">13456</span></div>
				<el-button type="primary" size="mini" style="margin-left: 30px;">编辑模型</el-button>
				<el-button size="mini" style="margin-left: 10px;">取消修改</el-button>
			</div> -->
		</el-main>
		<!-- <el-footer>
			<div style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-top: 40%;">
				<div class="err" style="color: red;line-height: 30px;text-align: center;font: 14px Arial, Helvetica, sans-serif;margin-bottom: 10px;">您有新的修改尚未发布</div>
				<el-button type="primary" size="mini">发布模型</el-button>
			</div>
		</el-footer> -->
	</el-container>
</template>

<script>

export default {
	name: 'model',
	data() {
		return {
			model1:"简单模型",
			model2:"高级模型",
			publishModelForm:{
				createId:this.util.getLocalAccount().id
			},
			AIModelStatus:{
				corpusTotal:0,
				status:0,
				talkCorpusTotal:0,
				topicTotal:0,
				updateTime:""
			},
			simpleModelStatus:{
				updateTime:""
			},
			waitPublish:false,
			canotEdit:false
		};
	},
	
	mounted() {
		this.publishCountSelect()
	},
	methods: {
		editSimpleModel(){
			this.$router.push({
				path: '/setting/simplemodel'
			});
		},
		async publishCountSelect(){
			var api = "/manager/talkCorpus/publishCount"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data: {},
			})
			console.log(response.data)
			this.AIModelStatus=response.data.aiModelVo
			this.simpleModelStatus=response.data.simpleModelVo
			if(this.AIModelStatus.status==3){
				this.waitPublish=true
			}else if(this.AIModelStatus.status==2||this.AIModelStatus.status==1){
				this.canotEdit=true
			}else{
				this.waitPublish=false
			}
			this.$store.state.AIstatus = this.AIModelStatus.status
		},
		async startEditAIModel(){
			var api = "/manager/talkCorpus/editModelStatus"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data: {},
			})
			console.log(response)
			if(response.resultCode=="10000"){
				this.$store.state.AIstatus = "1"
				console.log("this.$store.state.AIstatus =",this.$store.state.AIstatus)
				this.$router.push({
					path: '/setting/indeterminate'
				});
			}else{
				this.$message.error(response.desc)
			}
		},
		async publishModel(){
			var api = "/manager/talkCorpus/publish"
			const response = await this.util.postRequest({
				itype:"1",
				url: api,
				method: "POST",
				data: {
					
				}
			})
			console.log(response)
			if(response.resultCode=="10000"){
				const tipMsg = "模型发布成功"
				this.$message({
					message:tipMsg,
					type:'success'
				})
				this.publishCountSelect()
			}else{
				this.$message.error(response.desc)
			}
		}
	}
};
</script>

<style lang="scss">
.simple {
	width: 90%;
	height: 120px;
	border: 15px;
	box-shadow: 2px 2px 10px #C0C4CC;
	border-radius: 0.3125rem 0.3125rem 0.3125rem 0.3125rem;
	background-color: #ffffff;
	margin-top: 30px;
	line-height: 120px;
	@include change_size($font_size_normal)
}
.complex {
	width: 90%;
	height: 150px;
	border: 15px;
	box-shadow: 2px 2px 10px #C0C4CC;
	border-radius: 0.3125rem 0.3125rem 0.3125rem 0.3125rem;
	background-color: #ffffff;
	margin-top: 30px;
	display: flex;
	flex-direction: column;
	@include change_size($font_size_normal)
}
.con {
	display: flex;
	height: 30px;
	font-size: 15px;
	line-height: 35px;
	@include change_size($font_size_normal)
}
.data {
	color: #409eff;
	height: 50px;
	line-height: 35px;
	@include change_size($font_size_normal)
}
.el-radio__input.is-checked + .el-radio__label {
	color: #ff3f51 !important;
}
</style>
